import React, { Component } from "react";
import {Container, Row, Col,Image,Accordion,Button,OverlayTrigger,Tooltip  } from 'react-bootstrap';
import { withRouter,Link } from "react-router-dom";
import loader from '../../images/loader.gif';
import "../EventsAndActivities/EventsAndActivities.css";
import axios from 'axios';
import { getAPICallDataForOnlyBSA } from '../../services/MemberService';

class D2DCampaignSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chatID: window.User !=undefined ? window.User.chatID : "943827154",
      campaignsArr:[],
      campaignsArrCheck:0,
      authenticationMsg:"",
      userIdSet:"",
      userTokenSet:""
    };
    
    
  }

  componentDidMount() {
  
   this.getMembershipNoByChatId();
  }


  getMembershipNoByChatId = () => {
        const obj =  
        JSON.stringify({ 
            "chatId" :this.state.chatID,
        }); 
    
        getAPICallDataForOnlyBSA(obj,"getMembershipIdByChatId")
        .then((res) => res.json())
        .then((data) => {
            this.setState({authenticationMsg:""})
            if(data !=null){
                if(data.membershipId !=null && data.membershipId !=""){
                    this.getD2DCampaignUserId(data.membershipId,"membership");
                }else{
                     this.getMobileNoByChatId();
                }

            }else if(data !=null && data.status == "Fail"){
                this.setState({authenticationMsg:data.message})
            }
        });
    }


  getMobileNoByChatId = () => {
        const obj =  
        JSON.stringify({ 
            "chatId" :this.state.chatID,
        }); 
    
        getAPICallDataForOnlyBSA(obj,"getMobileNoByChatId")
        .then((res) => res.json())
        .then((data) => {
            this.setState({authenticationMsg:""})
            if(data !=null && data.mobileNo !=null){
                this.getD2DCampaignUserId(data.mobileNo,"mobile");

            }else if(data !=null && data.status == "Fail"){
                this.setState({authenticationMsg:data.message})
            }
        });
    }

    getD2DCampaignUserId = async(paramValue,objectType) => {
        var payload={};
        if(objectType == "membership"){
            payload={"membershipId" : paramValue};
        }else{
            payload={"mobileNo" : paramValue};
        }
        try {
        const response = await axios.post(
            'https://api.mytdpapp.com/megatron/mytdp/iam/api/v1/users/telegram/login',
            payload,
            {
            headers: {
                'Content-Type': 'application/json'
            }
            }
        );
    
        if(response.data !=null && response.data?.userId !=null){
            this.setState({userIdSet:response.data?.userId,userTokenSet:response.data?.token});
            if (response?.data?.token) {
                this.fetchCampaigns(response.data?.token);
            }else{
                this.setState({authenticationMsg:"Authentication Failed"})
            }
            
        }else{
            this.setState({authenticationMsg:"Authentication Failed"})
        }
        } catch (error) {
            this.setState({authenticationMsg:"Authentication Failed"})
            console.error('❌ Failed to get token:', error.response?.data || error.message);
        }
    }

  /*getTokenForD2DCampaignPage1 = async() => {
    try {
      const response = await axios.get(
        'https://api.mytdpapp.com/megatron/mytdp/iam/api/v1/users/admin',
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
  
      const token = response.data.token; // or adjust key as per actual response
      console.log('✅ Token:', token);
  
     this.fetchCampaigns(token);
     
    } catch (error) {
      console.error('❌ Failed to get token:', error.response?.data || error.message);
    }
  }*/


  fetchCampaigns = async (token) => {
    this.setState({campaignsArrCheck:0,campaignsArr:[]})
    try {
        const response = await axios.get('https://api.mytdpapp.com/megatron/pp/api/v1/campaigns?offset=0&limit=2147483647', {
        headers: {
            Authorization: `Bearer ${token}`
        }
        });

        if(response.data !=null){ 
            if(response.data?.data !=null && response.data?.data?.length>0){
                 this.setState({campaignsArr:response.data?.data,campaignsArrCheck:0})
            }else{
                 this.setState({campaignsArr:[],campaignsArrCheck:1})
            }
           
        }else{
              this.setState({campaignsArr:[],campaignsArrCheck:1})
        }

        console.log("Data:", response.data);
    } catch (error) {
        this.setState({campaignsArr:[],campaignsArrCheck:1})
        console.error("Error fetching campaigns:", error.response?.data || error.message);
    }
}

  render() {
    
    
    return (
      <section className="mb-4">
        <div className=''>
            <Image variant="top" src={require('../../images/D2D_image.jpeg')} className='w-100' style={{height:"170px"}} />
        </div>
        <div className='p-1'>
            <Container>
                <Row>
                    <Col>
                        <div className="float-right mt-2">
                            <Link to={{pathname: "/dashboard"}}> 
                                <Button variant="outline-danger pad5_14" className='f-12  fw-bold'> <i class="fa-solid fa-house"></i></Button> 
                            </Link>
                        </div>
                    </Col>
                </Row>
               {/* <Row>
                    <Col>
                        <div className='bor-bottom-yellow-pad mt-3'>
                            <h5 className='text-center color_red text-uppercase'>D2D Campaign
                               
                            </h5>
                        </div>
                    </Col>
                </Row>*/}

                {
                    this.state.authenticationMsg == "Authentication Failed" ? 
                    (
                        <Row>
                            <Col>
                                <h4 className='color_red mt-3'>Session Expired...Please Close Then Reopen Telegram Bot</h4>
                            </Col>
                        </Row>
                    )
                    :
                    (
                        <Row>
                            {
                            this.state.campaignsArr.length == 0 ?
                                    (
                                        this.state.campaignsArrCheck == 1 ?
                                        (<Col className='f-14 text-center mt-3'>Campaigns Are Not Available</Col>)
                                        :
                                        (<Col sm={12}>
                                        <div class="spinner-border color_yellow loading-img-center mt-4"></div>
                                        </Col>)
                                    )
                                    :
                                    (
                                        this.state.campaignsArr.length>0 ?
                                            (
                                                this.state.campaignsArr.map((item,index) => {
                                                    return(
                                                        <Row>
                                                            <Col sm={12} key={index} className="mt-3">
                                                                    <Link to={{
                                                                        pathname: "/campaign_wise_houses",
                                                                        params: {
                                                                            navbarDisplay:"hide",
                                                                            campaignId:item.id,
                                                                            campaignName:item.name,
                                                                            boothParam:{},
                                                                            constituencyParam:{},
                                                                            userIdSet:this.state.userIdSet
                                                                        
                                                                        }
                                                                    }} className="color_black_no_underline">
                                                                    <div className="campaign_block mt-2">
                                                                            <div>
                                                                            <h6 className='f-14 fw-bold'>{item.name}  
                                                                            </h6>
                                                                            </div>
                                                                        
                                                                            <div className='mt-2'>
                                                                            <Row>
                                                                                <Col>
                                                                                    <OverlayTrigger key={"top"} placement={"top"}
                                                                                        overlay={
                                                                                            <Tooltip id={`tooltio-Filter`}>
                                                                                            <h6 className='f-12'>Start Event...</h6>
                                                                                            </Tooltip>
                                                                                        }
                                                                                    >
                                                                                    <Button variant="outline-danger" className='mt-3 float-end f-12 pad_10_5 fw-bold button_red'>Start Now <i class="fa-solid fa-arrow-right ms-1"></i></Button> 
                                                                                    </OverlayTrigger>
                                                                                
                                                                                </Col>
                                                                            </Row>
                                                                            
                                                                            </div>
                                                                            
                                                                            </div>
                                                                        </Link>
                                                                </Col>
                                                        </Row>
                                                    )
                                                })
                                            
                                            )
                                            :
                                            ("")
                                )
                            }
                            </Row>
                    )
                }
                
                    
                

            </Container>
        </div>
     </section>

    );
  }
}

export default withRouter(D2DCampaignSection);
